<template>
    <b-container>
        <h3>Menü:</h3>
        <hr class="mt-4 mb-4">
        <b-list-group v-if="loaded">
            <draggable v-model="navigation" group="people" handle=".handle" @change="savePositions()">
                <div v-for="nav in navigation" :key="nav.position">
                    <b-list-group-item v-if="nav.dropdown_id === null" align-h="between">
                        <b-row>
                            <b-col>
                                <b-icon-file-text/>
                                <router-link :to="{ path: `/${nav.id}/Sektionen` }">{{ nav.name }}</router-link>
                            </b-col>
                            <b-col cols="1">
                                <b-icon-trash @click="confirmDeleteSite(nav.id)"></b-icon-trash>
                            </b-col>
                            <b-col cols="1">
                                <b-icon-list class="handle"></b-icon-list>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item v-if="nav.dropdown_id !== null" align-h="between">
                        <b-row>
                            <b-col>
                                <b-icon-caret-down-fill/>
                                <router-link :to="{ path: `/Dropdown/${nav.id}/Seiten` }">{{ nav.name }}</router-link>
                            </b-col>
                            <b-col cols="1">
                                <b-icon-trash @click="confirmDeleteDropdown(nav.id)"></b-icon-trash>
                            </b-col>
                            <b-col cols="1">
                                <b-icon-list class="handle"></b-icon-list>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </div>
            </draggable>
        </b-list-group>
        <hr class="mt-4 mb-4" v-if="loaded">
        <h4>Neues Dropdown:</h4>
        <b-input-group>
            <b-form-input v-model="dropdownName"></b-form-input>
            <b-input-group-append>
                <b-button variant="outline-success" @click="createDropdown(dropdownName)">Erstellen
                </b-button>
            </b-input-group-append>
        </b-input-group>
        <h4>Neue Seite:</h4>
        <b-input-group>
            <b-form-input v-model="siteName"></b-form-input>
            <b-input-group-append>
                <b-button variant="outline-success" @click="createSite({ siteName })">Erstellen
                </b-button>
            </b-input-group-append>
        </b-input-group>

    </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import draggable from 'vuedraggable'
import helpers from "@/helpers";
import {BIconList, BIconTrash, BIconFileText, BIconCaretDownFill} from 'bootstrap-vue'

export default {
    components: {
        draggable,
        BIconList,
        BIconTrash,
        BIconFileText,
        BIconCaretDownFill
    },
    data() {
        return {
            dropdownName: "",
            siteName: "",
            navigation: [],
        }
    },
    name: "NavigationList",
    mounted() {
        this.getDropdowns()
        this.getNavigationSites()
    },
    methods: {
        ...mapActions([
            'getDropdowns',
            'getNavigationSites',
            'createDropdown',
            'createSite',
            'saveDropdownPositions',
            'saveSitePositions',
            'deleteDropdown',
            'deleteSite',
        ]),
        savePositions() {
            let dropdowns = []
            let sites = []
            this.navigation.map((nav, index) => {
                if (nav.dropdown_id === null) {
                    sites.push({id: nav.id, position: index})
                } else {
                    dropdowns.push({id: nav.id, position: index})
                }
            })
            try {
                this.saveDropdownPositions(dropdowns)
                this.saveSitePositions({sites, dropdownId: null})
                helpers.handleSuccessMessage("Die Reihenfolge wurde gespeichert!")
            } catch (e) {
                helpers.handleWarningMessage("Die Reihenfolge konnte nicht gespeichert werden!")
            }
        },
        confirmDeleteDropdown(dropdownId) {
            this.$bvModal.msgBoxConfirm('Wollen Sie das Dropdown wirklich löschen ?', {
                title: 'Löschen',
                okVariant: 'outline-danger',
                okTitle: 'Ja',
                cancelTitle: 'Abbrechen',
                cancelVariant: 'outline-success',
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.deleteDropdown(dropdownId)
                    }
                })
        },
        confirmDeleteSite(siteId) {
            this.$bvModal.msgBoxConfirm('Wollen Sie die Seite wirklich löschen ?', {
                title: 'Löschen',
                okVariant: 'outline-danger',
                okTitle: 'Ja',
                cancelTitle: 'Abbrechen',
                cancelVariant: 'outline-success',
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.deleteSite(siteId)
                    }
                })
        },
        setNavigation() {
            const all = this.dropdowns.concat(this.sites)
            this.navigation = all.sort((a, b) => {
                return a.position - b.position
            })
        }
    },
    computed: {
        ...mapGetters([
            'getStoredDropdowns',
            'getStoredSites',
            'getDropdownState',
            'getSitesState',
        ]),
        dropdowns() {
            return this.getStoredDropdowns
        },
        sites() {
            return this.getStoredSites
        },
        dropdownsState() {
            return this.getDropdownState
        },
        sitesState() {
            return this.getSitesState
        },
        loaded() {
            return this.dropdownsState === 'finished' && this.sitesState === 'finished'
        },
        loading() {
            return this.dropdownsState === 'loading' || this.sitesState === 'loading'
        },
        error() {
            return this.dropdownsState === 'error' || this.sitesState === 'error'
        },
    },
    watch: {
        dropdowns: function () {
            this.setNavigation()
        },
        sites: function () {
            this.setNavigation()
        },
    },
}
</script>

<style scoped>

</style>
